import Config from '../config/constants';
import axios, { AxiosResponse } from 'axios';

export const apiGetOwnerMachines = async (
  userid: string,
  accessToken: string,
): Promise<AxiosResponse> => {
  console.log('userid=' + userid);
  const url = `${Config.API_HOST}/api/admin/machine/owner_machinelist/${userid}`;

  try {
    const response = await axios.get(url, {
      headers: { access_token: accessToken },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
